module.exports = __webpack_public_path__ + "img/u12_state0.e358a05a.png";